/*eslint-disable*/
import api from '../'

class CatchWordApi {
    static getGroups (locale) {
        return api.axios.get('/catch-word-reading-en/groups', { params: { locale }}).then(response => response.data);
    }

    static getGameItems (params) {
        return api.axios.get('/catch-word-reading-en/items', { params }).then(response => response.data);
    }

    static checkIfEnoughWords (params) {
        return api.axios.get('/catch-word-reading-en/check-if-enough-words', { params }).then(response => response.data);
    }
}

export default CatchWordApi;
